import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div<{ $isPrimary: boolean }>`
  z-index: 1;
  display: inline-flex;
  background-color: ${Colors.Neutral10};
  border-radius: ${Spacing['3XL']};
  padding: ${Spacing.XS} ${Spacing.S};
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.Neutral100};
  gap: 10px;
  height: 50px;
  align-items: center;
  cursor: pointer;
  width: fit-content;

  &:hover {
    background-color: ${Colors.Neutral15};
  }

  ${({ $isPrimary }) =>
    $isPrimary &&
    css`
      background-color: ${Colors.Blue10};
      color: ${Colors.Blue50};

      &:hover {
        background-color: ${Colors.Blue20};
      }
    `}
`
